module.exports = __webpack_public_path__ + "static/media/reminder.2c51f81e.png";